import React, { useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import ActionItems from '../../../components/ActionItems';
import { makeStyles } from '@material-ui/core/styles';
import Schedule from '../Schedule';
import PerformanceScoreCard from '../../../components/Results';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

/* --- helpers --- */
const invertColor = (hex: string) => {
  const c = (hex || '#ffffff').replace(/^#/, '');
  const full = c.length === 3 ? c.split('').map(x => x + x).join('') : c;
  const n = parseInt(full || 'ffffff', 16);
  const r = 255 - ((n >> 16) & 255);
  const g = 255 - ((n >> 8) & 255);
  const b = 255 - (n & 255);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

const useStyles = makeStyles(theme => ({
  container: (props: { bg: string; fg: string; font: string }) => ({
    padding: theme.spacing(3),
    backgroundColor: props.bg,
    color: props.fg,
    minHeight: '100vh',
    fontFamily: props.font,
  }),
}));

const ClientDashboard = () => {
  const { singleProgram } = useSelector((s: RootState) => s.programReducer);

  const { bg, fg, font } = useMemo(() => {
    const active = JSON.parse(localStorage.getItem('activeProgramEnrollment') || '{}');
    const communityId = active?.communityIdentifier;
    const community = singleProgram?.communities?.find(
      (c: any) => c?.communityIdentifier === communityId
    );

    const style = (community as any)?.communityStyle || {};
    const mainColor = style.mainColor ?? '#1976d2';
    const secondaryColor =
      style.secondaryColor ?? style.generalColor ?? '#121212'; // fallback if theme missing
    const fontStyle = style.fontStyle ?? 'Arial';

    // page background + readable text color
    const pageBg = secondaryColor;
    const pageFg = invertColor(pageBg);

    return { bg: pageBg, fg: pageFg, font: fontStyle };
  }, [singleProgram]);

  const classes = useStyles({ bg, fg, font });

  return (
    <div className={classes.container}>
      {/* Your dashboard content goes here */}
      {/* Example layout if/when you add widgets: */}
      {/* <Grid container spacing={3}>
        <Grid item xs={12} md={6}><ActionItems /></Grid>
        <Grid item xs={12} md={6}><PerformanceScoreCard /></Grid>
        <Grid item xs={12}><Schedule /></Grid>
      </Grid> */}
    </div>
  );
};

export default ClientDashboard;
